// archive-list.jsx — First Round Review 風 編集マガジンレイアウト v2
//
// 1ページ目（検索なし）レイアウト:
//   ┌────────────────────────────────────────┐
//   │  Sub-hero (既存 HBSubHero)               │
//   │  Sticky filter / 検索                     │
//   ├──────┬─────────────────┬──────┤
//   │ Card │      Hero (大)        │ Browse │
//   │ Vert │  3:2 image            │  by    │
//   │ 4:5  │  Serif H1 (大)        │  Cat.  │
//   │      │  Excerpt              │ (vert) │
//   │      │  Date · Cat           │        │
//   ├──────┴─────────────────┴──────┤
//   │ Latest Reads (4 column)                  │
//   │  ┌──┐┌──┐┌──┐┌──┐                  │
//   │  │3:2││3:2││3:2││3:2│                  │
//   │  └──┘└──┘└──┘└──┘                  │
//   │   …                                       │
//   ├─────────────────────────────────────┤
//   │ Numeric pager (1 2 3 … 55)               │
//   ├─────────────────────────────────────┤
//   │ End CTA                                  │
//   └─────────────────────────────────────┘
//
// 2ページ目以降 / 検索 / カテゴリ絞り込み時:
//   Sub-hero → Sticky filter → 4 column grid → pager → CTA
//
// Trending sidebar は人気投稿データを持たないため、代わりに
// "Browse by category" を右レーンに置き、ナビゲーション機能を強化する。

(function(){
  const { HBLayout, HBSubHero, hbcp, fontEN, fontENSans, fontJP, fontMono, HB_BASE } = window;
  const fontSerif = fontJP; /* 硬い明朝→サイト標準フォントに統一 (Setoguchi #42-3/#44-3) */
  const MAXW = 1200;

  /**
   * Featured Topics 用のカテゴリカラー mapping。
   * カテゴリ slug を key にし、bg / text の組み合わせを返す。
   * FRR の "Paths to PMF (緑)" / "Loved by experts (紫)" の 2 色軸を意識し、
   * 弊社では AI=深青 / DX=深ティール / 研修=テラコッタ / 会計=ボルドー
   * の 4 色アクセントで series 感を演出する。
   */
  const TOPIC_PALETTE = {
    'ai':       { bg:'#1F4F8F', text:'#FFFFFF', accent:'rgba(255,255,255,.85)' },  // deep blue
    'dx':       { bg:'#1A4D4D', text:'#FFFFFF', accent:'rgba(255,255,255,.85)' },  // deep teal
    'contents': { bg:'#A65A38', text:'#FFFFFF', accent:'rgba(255,255,255,.85)' },  // terracotta
    '%e4%bc%9a%e8%a8%88': { bg:'#5C2B45', text:'#FFFFFF', accent:'rgba(255,255,255,.85)' }, // bordeaux (会計)
    '_default': { bg:'#0A2846', text:'#FFFFFF', accent:'rgba(255,255,255,.85)' },
  };
  function paletteFor( slug ) { return TOPIC_PALETTE[ slug ] || TOPIC_PALETTE._default; }

  /**
   * Topic カード中央に置く editorial tagline。
   * FRR の "Paths to PMF" 風 — 短い1〜2行で、その topic を読む意味を伝える。
   */
  // ※ "contents" slug は WP DB 上「研修」カテゴリ（過去リネーム残）。
  const TOPIC_TAGLINE = {
    'ai':       'OpenAI／Anthropic／Google の最前線、エージェント設計、エンジニアリング自動化、社内ナレッジベースの実装まで。AI を「触る」フェーズから「業務に効かせる」フェーズへ。',
    'dx':       'kintone・freee・Slack を軸にした内製化、ノーコード／ローコードで業務を変える設計、現場で泥臭く効いた打ち手まで、外注に任せず自分たちで動かすための知見を集めました。',
    'contents': '社内研修・L&D・新卒オンボーディング・マネジメント教育。属人化した OJT を仕組みに変え、人と組織を育てる打ち手を集めた特集。',
    '%e4%bc%9a%e8%a8%88': '管理会計・税務 DX・freee 実装・経理の自動化。経営判断に効く数字の作り方と、属人化した経理を仕組みに変えるアプローチ。',
  };
  function taglineFor( slug, name ) {
    return TOPIC_TAGLINE[ slug ] || `${name} に関する最新の動向と、実務に効くケーススタディや考察を集めた特集ページ。経営層・実務担当者の双方が迷わず判断できる材料を提供します。`;
  }

  // 表示する Featured Topics 用カテゴリ（カウント上位 4 件 / LP 系は除外）
  function pickFeaturedCats( cats ) {
    return [ ...cats ]
      .filter( c => ! /-lp$/.test( c.slug ) ) // dx-lp / bi-lp / content-lp は除外
      .sort( (a,b) => (b.count||0) - (a.count||0) )
      .slice( 0, 4 );
  }

  function ArchiveListPage() {
    const data = window.HB_ARCHIVE || { en:'Archive', jp:'一覧', posts:[], total:0, page:1, max_page:1, lead:'', cats:[], all_url:'#', active_cat:'all' };
    // 投稿の excerpt から「この記事のポイント」のような lead 文ラベルを撲滅。
    // 全投稿に共通する label 様の文言は記事間の差別化に寄与せず、
    // カードの excerpt として表示すると読者ノイズになるため。
    const _stripLabelPrefix = (s) => (s == null ? '' : String(s))
      .replace(/^[\s　]*この記事のポイント[\s　]*/, '')
      .replace(/^[\s　]*(?:概要|要約|サマリ(?:ー)?|TL;DR|まとめ)[\s　:：]*/, '')
      .trim();
    const _cleanPosts = (data.posts || []).map( p => ({ ...p, excerpt: _stripLabelPrefix(p.excerpt) }));
    const { en, jp, total, page, max_page, lead, prev_url, next_url, cats=[], top_tags=[], all_url='#', active_cat='all', active_tag='' } = data;
    const posts = _cleanPosts;
    const [q, setQ] = React.useState('');
    const [showAllTags, setShowAllTags] = React.useState(false);
    // tagModalOpen は下段「タグで探す」セクションのモーダル用。Rules-of-Hooks 違反を避けるため、
    // 検索結果 0 件で当該セクションが unmount される条件下でも hooks 数を一定に保つ目的で上に移動。
    const [tagModalOpen, setTagModalOpen] = React.useState(false);

    // 検索のみクライアントフィルタ。カテゴリは server-side。
    const filtered = React.useMemo(() => {
      if (!q.trim()) return posts;
      const ql = q.trim().toLowerCase();
      return posts.filter(p =>
        (p.title||'').toLowerCase().includes(ql) ||
        (p.excerpt||'').toLowerCase().includes(ql)
      );
    }, [posts, q]);

    const isFeaturedView = page === 1 && !q.trim() && active_cat === 'all';
    // archive 種別判定: /blog/ はブログ記事一覧、/achievements/ や /office-news/ などは
    // 性質の異なるアーカイブ。「分野別 新着」「人気キーワード」のような
    // ブログ流のセクションは Blog アーカイブでのみ表示する。
    const isBlog = (data.post_type === 'blog') || (en === 'Blog') || /ブログ/.test(jp || '');
    // News / お知らせ系: ブログ風マストヘッドを使わず、シンプルな見出しを表示する。
    // 「The HatenaBase Review」「日付」「全N記事」「Nテーマ」は News には不適切。
    const isNewsLike = (en === 'News') || /お知らせ|ニュース/.test(jp || '');
    // 旧: Hero Strip (filtered[0..2]) + 新着記事グリッド (filtered.slice(3)) の二段構成。
    // 新: Hero Strip 撤廃。新着記事グリッドが画面トップに位置し、filtered 全体を表示する。
    const restPosts    = filtered;

    return (
      <HBLayout>
        {/* ===== Newspaper masthead (Blog のみ。News / お知らせはシンプル見出しに切替) ===== */}
        {false ? ( /* ブログもニュース形式の見出しに統一・The HatenaBase Review撤去 (Setoguchi #44-1/#44-2) */
          <section className="hb-archive-masthead" style={{background:hbcp.white, borderBottom:`1px solid ${hbcp.line}`}}>
            <div style={{maxWidth:MAXW, margin:'0 auto', padding:'12px 32px 10px', textAlign:'center'}}>
              <div className="hb-archive-masthead__bar" style={{display:'flex', alignItems:'baseline', justifyContent:'space-between', gap:14, fontFamily:fontMono, fontSize:10.5, color:hbcp.inkLight, letterSpacing:'.18em', textTransform:'uppercase', borderTop:`1px solid ${hbcp.ink}`, borderBottom:`1px solid ${hbcp.line}`, padding:'8px 0', flexWrap:'wrap'}}>
                <div style={{flex:'1 1 30%', textAlign:'left'}}>
                  {(()=>{ try { return new Date().toLocaleDateString('en-US',{weekday:'long', year:'numeric', month:'long', day:'numeric'}); } catch(e){ return ''; } })()}
                </div>
                <div style={{flex:'1 1 30%', textAlign:'center', fontWeight:600, color:hbcp.ink}}>
                  全 {total} 記事 ／ {cats.length} テーマ
                </div>
                <div style={{flex:'1 1 30%', textAlign:'right'}}>
                  <a href={HB_BASE} style={{color:'inherit', textDecoration:'none', marginRight:14}}>ホーム</a>
                  <span style={{color:hbcp.ink, fontWeight:600}}>{jp || en}</span>
                </div>
              </div>
              <h1 className="hb-archive-masthead__title" style={{fontFamily:fontSerif, fontWeight:700, fontSize:'clamp(28px, 3.6vw, 42px)', lineHeight:1.05, letterSpacing:'.04em', margin:'12px 0 4px', color:hbcp.ink}}>
                The HatenaBase Review
              </h1>
              <p className="hb-archive-masthead__tagline" style={{fontFamily:fontJP, fontSize:'clamp(11px, 1.1vw, 13px)', color:hbcp.inkLight, letterSpacing:'.12em', margin:'0 0 10px'}}>
                攻めのバックオフィスの知恵袋
              </p>
              <div style={{borderTop:`3px solid ${hbcp.ink}`, marginTop:4}}/>
              <div style={{borderTop:`1px solid ${hbcp.ink}`, marginTop:3}}/>
            </div>
          </section>
        ) : (
          <section className="hb-archive-simple-head" style={{background:hbcp.white, borderBottom:`1px solid ${hbcp.line}`}}>
            <div style={{maxWidth:MAXW, margin:'0 auto', padding:'40px 32px 28px'}}>
              <div style={{fontFamily:fontENSans, fontSize:11, fontWeight:500, letterSpacing:'.32em', color:hbcp.blue, marginBottom:8}}>● {(en || '').toUpperCase() || 'NEWS'}</div>
              <h1 style={{fontFamily:fontJP, fontWeight:800, fontSize:'clamp(26px, 3.4vw, 36px)', lineHeight:1.2, letterSpacing:'.04em', margin:0, color:hbcp.ink}}>{jp || en || 'お知らせ'}</h1>
              {lead && <p style={{fontSize:13.5, lineHeight:1.85, color:hbcp.inkSoft, margin:'14px 0 0', maxWidth:680}}>{lead}</p>}
            </div>
          </section>
        )}

        {/* Sticky filter (FRR は最小限の検索だけ。タブはそのまま残す) */}
        {(cats.length > 0 || posts.length > 0) && (
          <div className="hb-arc-filterbar" style={{borderBottom:`1px solid ${hbcp.line}`, background:hbcp.white, position:'sticky', top:72, zIndex:30}}>
            <div style={{maxWidth:MAXW, margin:'0 auto', padding:'14px 32px', display:'flex', gap:24, alignItems:'center', flexWrap:'wrap'}}>
              {cats.length > 0 ? (
                <div className="hb-arc-cattabs" style={{display:'flex', gap:0, overflowX:'auto', flex:1, minWidth:0}}>
                  <CatTab active={active_cat==='all'} href={all_url}>
                    All <span style={{color:hbcp.inkLight, fontFamily:fontMono, fontSize:11}}>({total})</span>
                  </CatTab>
                  {cats.map(c => (
                    <CatTab key={c.slug} active={active_cat===c.slug} href={c.url}>
                      {c.name} <span style={{color:hbcp.inkLight, fontFamily:fontMono, fontSize:11}}>({c.count})</span>
                    </CatTab>
                  ))}
                </div>
              ) : <div style={{flex:1}}/>}
              {/* 検索フォーム:
                  ・入力中は現在ページの 12 件を instant filter（即時フィードバック）
                  ・Enter で WP 標準検索 (`/?s=foo&post_type=blog`) に submit し、全 {total} 記事を対象に search.php で検索
                  ・空入力での submit は抑止（無意味なヒット 0 件ページ生成を防ぐ） */}
              <form action="/" method="get" role="search" className="hb-arc-search"
                    onSubmit={e => { if (!q.trim()) e.preventDefault(); }}
                    style={{display:'flex', alignItems:'center', gap:8, padding:'6px 0', borderBottom:`1px solid ${hbcp.line}`, minWidth:280}}>
                <input type="hidden" name="post_type" value="blog"/>
                <span style={{fontFamily:fontEN, color:hbcp.blue}}>⌕</span>
                <input name="s" type="search" value={q} onChange={e=>setQ(e.target.value)}
                       placeholder="Search articles" aria-label="記事を検索" className="hb-arc-search__input"
                       style={{border:'none', outline:'none', fontFamily:fontJP, fontSize:13, width:'100%', background:'transparent', minWidth:0}}/>
                {q.trim() && (
                  <>
                    <span style={{fontFamily:fontMono, fontSize:9.5, color:hbcp.inkLight, whiteSpace:'nowrap', flexShrink:0}}>
                      このページ内 {filtered.length} 件
                    </span>
                    <button type="submit"
                            title={`Enter で全 ${total} 件から検索`}
                            style={{border:'none', background:'transparent', cursor:'pointer', padding:0, fontFamily:fontMono, fontSize:10, color:hbcp.blue, whiteSpace:'nowrap', flexShrink:0, fontWeight:700}}>
                      全件 Enter →
                    </button>
                  </>
                )}
              </form>
            </div>
            {/* タグ行 (カテゴリの下、少し小さめのサイズで top 15 + もっと見る) */}
            {top_tags.length > 0 && (
              <div className="hb-tag-row" style={{borderTop:`1px solid ${hbcp.line}`, background:hbcp.paper}}>
                <div style={{maxWidth:MAXW, margin:'0 auto', padding:'8px 32px', display:'flex', alignItems:'center', gap:12, flexWrap: showAllTags ? 'wrap' : 'nowrap'}}>
                  <span style={{fontFamily:fontENSans, fontSize:9, letterSpacing:'.24em', fontWeight:700, color:hbcp.inkLight, flexShrink:0}}>TAGS</span>
                  <div style={{display:'flex', gap:6, overflowX: showAllTags ? 'visible' : 'auto', flex:1, minWidth:0, flexWrap: showAllTags ? 'wrap' : 'nowrap', paddingBottom: showAllTags ? 0 : 2}}>
                    {(showAllTags ? top_tags : top_tags.slice(0, 15)).map(t => {
                      const isActiveTag = active_tag && t.slug === active_tag;
                      return (
                        <a key={t.slug} href={t.url}
                          style={{display:'inline-flex', alignItems:'baseline', gap:4, padding:'3px 10px', fontFamily:fontJP, fontSize:11.5, textDecoration:'none', whiteSpace:'nowrap', borderRadius:2,
                            border: `1px solid ${isActiveTag ? hbcp.blue : hbcp.line}`,
                            background: isActiveTag ? hbcp.blue : '#fff',
                            color: isActiveTag ? '#fff' : hbcp.ink,
                            fontWeight: isActiveTag ? 700 : 400,
                          }}>
                          <span>#{t.name}</span>
                          <span style={{fontFamily:fontMono, fontSize:9, color: isActiveTag ? 'rgba(255,255,255,.65)' : hbcp.inkLight}}>{t.count}</span>
                        </a>
                      );
                    })}
                    {top_tags.length > 15 && (
                      <button onClick={() => setShowAllTags(!showAllTags)}
                        style={{display:'inline-flex', alignItems:'center', gap:4, padding:'3px 10px', fontFamily:fontJP, fontSize:11.5, fontWeight:700, color:hbcp.blue, textDecoration:'none', whiteSpace:'nowrap', border:`1px solid ${hbcp.blue}`, borderRadius:2, background:'#fff', cursor:'pointer'}}>
                        {showAllTags ? '閉じる' : `もっと見る (+${top_tags.length - 15})`}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Top products (商材) — /achievements/ で HB_ARCHIVE.top_products が injection された時のみ表示。
            8 件程度の製品パッケージ LP を carousel で見せ、"Show more" で /lp/ へ。 */}
        {data.top_products && Array.isArray(data.top_products.items) && data.top_products.items.length > 0 && (
          <section className="hb-archive-products" style={{padding:'56px 32px 64px', background:hbcp.paper, borderBottom:`1px solid ${hbcp.line}`}}>
            <div style={{maxWidth:MAXW, margin:'0 auto'}}>
              <div className="hb-section-head">
                <span className="hb-section-head-en">{data.top_products.eyebrow || 'Products'}</span>
                <span className="hb-section-head-jp">{data.top_products.jp || '商材'}</span>
                <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>{String(data.top_products.items.length).padStart(2,'0')} ITEMS</span>
              </div>
              <div className="hb-archive-products-grid" style={{display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gap:20}}>
                {data.top_products.items.map(p => (
                  <a key={p.permalink} href={p.permalink}
                     style={{display:'flex', flexDirection:'column', textDecoration:'none', color:hbcp.ink, background:'#fff', border:`1px solid ${hbcp.line}`, transition:'transform .15s ease, border-color .15s ease, box-shadow .15s ease'}}
                     className="hb-archive-product-card">
                    <div style={{aspectRatio:'16 / 9', overflow:'hidden', background:hbcp.paper}}>
                      {p.thumbnail
                        ? <img src={p.thumbnail} alt="" loading="lazy" style={{width:'100%', height:'100%', objectFit:'cover', display:'block'}}/>
                        : <div style={{width:'100%', height:'100%', display:'grid', placeItems:'center', color:hbcp.inkLight, fontFamily:fontEN, fontSize:22}}>—</div>}
                    </div>
                    <div style={{padding:'14px 16px 18px'}}>
                      <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:13.5, lineHeight:1.45, letterSpacing:'.04em', margin:'0 0 8px', color:hbcp.ink}}>{p.title}</h3>
                      <div style={{fontFamily:fontEN, fontSize:13, color:hbcp.blue}}>詳しく見る →</div>
                    </div>
                  </a>
                ))}
              </div>
              {data.top_products.more_url && (
                <div style={{marginTop:32, display:'flex', justifyContent:'center'}}>
                  <a href={data.top_products.more_url}
                     style={{display:'inline-flex', alignItems:'center', gap:10, padding:'12px 28px', border:`1px solid ${hbcp.ink}`, background:'#fff', color:hbcp.ink, textDecoration:'none', fontFamily:fontJP, fontSize:14, fontWeight:700, letterSpacing:'.02em'}}>
                    {data.top_products.more_label || 'Show more'}
                    <span style={{fontFamily:fontEN}}>→</span>
                  </a>
                </div>
              )}
            </div>
          </section>
        )}

        {/* 事例セクションのヘッダー (HB_ARCHIVE.cases_heading が injection されている時のみ) */}
        {data.cases_heading && filtered.length > 0 && (
          <section style={{padding:'48px 32px 0', background:hbcp.white}}>
            <div style={{maxWidth:MAXW, margin:'0 auto'}}>
              <div className="hb-section-head">
                <span className="hb-section-head-en">{data.cases_heading.eyebrow || 'Case studies'}</span>
                <span className="hb-section-head-jp">{data.cases_heading.jp || '導入事例'}</span>
                <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>{String(total).padStart(2,'0')} CASES</span>
              </div>
              {data.cases_heading.lead && (
                <p style={{fontFamily:fontJP, fontSize:13.5, lineHeight:1.85, color:hbcp.inkSoft, margin:'0 0 8px', maxWidth:720}}>
                  {data.cases_heading.lead}
                </p>
              )}
            </div>
          </section>
        )}

        {filtered.length === 0 ? (
          <section style={{padding:'120px 32px', background:hbcp.white}}>
            <div style={{maxWidth:MAXW, margin:'0 auto', textAlign:'center', color:hbcp.inkLight, fontFamily:fontJP, fontSize:14}}>
              {q || active_cat!=='all' ? '条件に合う記事がありません。' : '記事はまだありません。'}
            </div>
          </section>
        ) : (
        <>
          {/* ===== Top: 新着記事 (画面の一番上 / 1+2+2x2 hierarchical / heading 無し) =====
              ユーザー指示: 旧 Hero Strip を撤廃し、ここに 新着記事 グリッドを配置。
              "新着記事" の heading も不要 (記事一覧であることは文脈で自明)。
              description (excerpt) も不要 — タイトルだけで十分という指示。 */}
          <section className="hb-arc-latest" style={{padding:'12px 10px 32px', background:hbcp.white}}>
            <div style={{maxWidth:MAXW, margin:'0 auto'}}>
              {isNewsLike ? (
                /* News / お知らせ系: アイキャッチ無しのリスト形式 (date / cat / title 横並び + 下罫線) */
                <div style={{borderTop:`1px solid ${hbcp.ink}`, maxWidth:920, margin:'0 auto'}}>
                  {restPosts.map(p => (
                    <a key={p.id} href={p.permalink} className="hb-arc-newsrow"
                       style={{display:'grid', gridTemplateColumns:'120px 140px 1fr 16px', alignItems:'baseline', gap:18, padding:'18px 4px', textDecoration:'none', color:hbcp.ink, borderBottom:`1px solid ${hbcp.line}`}}>
                      <div className="hb-arc-newsrow__date" style={{fontFamily:fontMono, fontSize:12, color:hbcp.inkLight}}>{p.date}</div>
                      <div className="hb-arc-newsrow__cat" style={{fontFamily:fontENSans, fontSize:10.5, fontWeight:700, letterSpacing:'.18em', color:hbcp.blue, textTransform:'uppercase'}}>{p.cat || ''}</div>
                      <h3 className="hb-arc-newsrow__title" style={{fontFamily:fontJP, fontWeight:600, fontSize:15, lineHeight:1.55, margin:0, color:hbcp.ink}}>{p.title}</h3>
                      <span style={{fontFamily:fontEN, fontSize:14, color:hbcp.blue, justifySelf:'end'}}>↗</span>
                    </a>
                  ))}
                </div>
              ) : (
                <div className="hb-grid-4" style={{display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gap:'48px 24px'}}>
                  {restPosts.map(p => (
                    <a key={p.id} href={p.permalink} className="hb-arc-card" style={{display:'flex', flexDirection:'column', textDecoration:'none', color:hbcp.ink, gap:0}}>
                      {/* 画像（16:9 統一 — 元アイキャッチが 768x403=16:9 のため） */}
                      <div className="hb-arc-card__media" style={{aspectRatio:'16 / 9', overflow:'hidden', background:hbcp.paper}}>
                        {p.thumbnail
                          ? <img src={p.thumbnail} alt="" loading="lazy" className="hb-arc-card__img" style={{width:'100%', height:'100%', objectFit:'cover', display:'block'}}/>
                          : <div style={{width:'100%', height:'100%', display:'grid', placeItems:'center', color:hbcp.inkLight, fontFamily:fontEN, fontSize:24}}>—</div>}
                      </div>
                      {/* Kicker (タイトル上) */}
                      {p.cat && <div className="hb-arc-card__kicker" style={{fontFamily:fontENSans, fontSize:9, letterSpacing:'.24em', fontWeight:700, color:hbcp.blue, marginTop:6, textTransform:'uppercase'}}>{p.cat}</div>}
                      {/* Title (line-clamp 3) */}
                      <h3 className="hb-arc-card__title" style={{fontFamily:fontSerif, fontWeight:700, fontSize:14.5, lineHeight:1.5, letterSpacing:'.04em', margin:'2px 0 4px', display:'-webkit-box', WebkitLineClamp:4, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{p.title}</h3>
                      {/* ArticleDeck (記事要約 / リード文) — タイトル下 */}
                      {p.deck && <p className="hb-arc-card__deck" style={{fontFamily:fontJP, fontSize:12, lineHeight:1.7, color:hbcp.inkSoft, margin:'0 0 6px'}}>{p.deck}</p>}
                      {/* Date 下端 */}
                      <div className="hb-arc-card__date" style={{fontFamily:fontMono, fontSize:10.5, color:hbcp.inkLight, marginTop:'auto', paddingTop:8}}>{p.date}</div>
                    </a>
                  ))}
                </div>
              )}
              {/* Numeric pager */}
              {max_page > 1 && (
                <NumericPager page={page} maxPage={max_page} basePath={data.base_path} prevUrl={prev_url} nextUrl={next_url}/>
              )}
            </div>
          </section>

          {/* ===== Sections (NYT / Economist 流 — 4 列セクション帯) =====
              hero の下 / Topics タイルの上に配置し、各カテゴリの最新記事を
              column-by-column で見せる「新聞紙面」感を再現する。
              ブログ専用 (導入事例 等の他アーカイブでは「分野別 新着」表現がそぐわないため非表示)。 */}
          {isBlog && isFeaturedView && (() => {
            // accent カラーは slug → 色のマッピングで動的に決定（palette と一致）
            const SECTION_ACCENT = {
              'ai':                    hbcp.blue,
              'dx':                    '#1A4D4D',
              'contents':              '#A65A38',
              '%e4%bc%9a%e8%a8%88':    '#5C2B45',
            };
            const SECTION_EYEBROW = {
              'ai':                    'AI ／ 機械学習',
              'dx':                    'DX ／ 業務改善',
              'contents':              '研修 ／ 人材育成',
              '%e4%bc%9a%e8%a8%88':    '会計 ／ ファイナンス',
            };
            // by_section はサーバ側で取得した「カテゴリ別最新4件」。最大 4 セクションまで表示。
            const sectionGroups = (data.by_section || []).slice(0, 4).map( g => ({
              ...g,
              accent:  SECTION_ACCENT[ g.slug ] || hbcp.ink,
              eyebrow: SECTION_EYEBROW[ g.slug ] || g.name,
              lead:    g.posts && g.posts[0],
              secondaries: g.posts ? g.posts.slice(1, 4) : [],
            })).filter( g => g.lead );
            if ( sectionGroups.length === 0 ) return null;
            return (
              <section className="hb-sections-band" style={{padding:'56px 32px 64px', background:hbcp.white, borderTop:`1px solid ${hbcp.ink}`}}>
                <div style={{maxWidth:MAXW, margin:'0 auto'}}>
                  <div className="hb-sections-band-head" style={{display:'flex', alignItems:'baseline', justifyContent:'space-between', borderBottom:`1px solid ${hbcp.ink}`, paddingBottom:10, marginBottom:28, gap:24, flexWrap:'wrap'}}>
                    <div>
                      <div style={{fontFamily:fontJP, fontSize:11, letterSpacing:'.04em', fontWeight:700, color:hbcp.blue, marginBottom:6}}>● 分野別 新着</div>
                      <h2 style={{fontFamily:fontSerif, fontWeight:700, fontSize:'clamp(20px, 2.2vw, 26px)', letterSpacing:'.04em', margin:0, color:hbcp.ink}}>
                        各テーマの、最新の一本
                      </h2>
                    </div>
                    <div style={{fontFamily:fontJP, fontSize:13, lineHeight:1.7, color:hbcp.inkSoft, maxWidth:520}}>AI・DX・研修・会計の各テーマから、現場の書き手が今いちばん届けたい記事を 1 本ずつ。</div>
                  </div>
                  <div className="hb-sections-grid" style={{display:'grid', gridTemplateColumns:`repeat(${sectionGroups.length}, 1fr)`, gap:0}}>
                    {sectionGroups.map( (g, gi) => (
                      <div key={g.slug}
                           style={{
                             padding:`0 ${gi === sectionGroups.length-1 ? 0 : 22}px 0 ${gi === 0 ? 0 : 22}px`,
                             borderRight: gi === sectionGroups.length-1 ? 'none' : `1px solid ${hbcp.line}`,
                             display:'flex', flexDirection:'column', gap:12,
                           }}>
                        {/* セクションヘッダ */}
                        <div style={{borderTop:`3px solid ${g.accent}`, paddingTop:8, marginBottom:4}}>
                          <div style={{fontFamily:fontJP, fontSize:11, fontWeight:700, color:g.accent, marginBottom:2}}>{g.eyebrow}</div>
                          <h3 style={{fontFamily:fontSerif, fontWeight:700, fontSize:18, letterSpacing:'.04em', margin:0, color:hbcp.ink}}>{g.name}</h3>
                        </div>
                        {/* Lead 記事（image + title + excerpt + date） */}
                        <a href={g.lead.permalink} style={{display:'flex', flexDirection:'column', textDecoration:'none', color:hbcp.ink, gap:8, paddingBottom:14, borderBottom:`1px solid ${hbcp.line}`}}>
                          <div style={{aspectRatio:'16 / 9', overflow:'hidden', background:hbcp.paper}}>
                            {g.lead.thumbnail
                              ? <img src={g.lead.thumbnail} alt="" style={{width:'100%', height:'100%', objectFit:'cover', display:'block'}}/>
                              : <div style={{width:'100%', height:'100%', display:'grid', placeItems:'center', color:hbcp.inkLight, fontFamily:fontEN, fontSize:24}}>—</div>}
                          </div>
                          <h4 style={{fontFamily:fontSerif, fontWeight:700, fontSize:15, lineHeight:1.35, letterSpacing:'.04em', margin:'4px 0 4px', color:hbcp.ink, display:'-webkit-box', WebkitLineClamp:4, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{g.lead.title}</h4>
                          {g.lead.excerpt && (
                            <p style={{fontFamily:fontJP, fontSize:11.5, lineHeight:1.75, color:hbcp.inkSoft, margin:'0 0 4px', display:'-webkit-box', WebkitLineClamp:3, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{g.lead.excerpt}</p>
                          )}
                          <div style={{fontFamily:fontMono, fontSize:10.5, color:hbcp.inkLight}}>{g.lead.date}</div>
                        </a>
                        {/* Stacked secondaries（headline-only リスト） */}
                        {g.secondaries.length > 0 && (
                          <ul style={{listStyle:'none', margin:0, padding:0}}>
                            {g.secondaries.map( (sp, i) => (
                              <li key={sp.id} style={{padding:'8px 0', borderBottom: i === g.secondaries.length-1 ? 'none' : `1px solid ${hbcp.line}`}}>
                                <a href={sp.permalink} style={{display:'block', textDecoration:'none', color:hbcp.ink}}>
                                  <h5 style={{fontFamily:fontSerif, fontWeight:600, fontSize:13, lineHeight:1.4, margin:'0 0 3px', display:'-webkit-box', WebkitLineClamp:3, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{sp.title}</h5>
                                  <div style={{fontFamily:fontMono, fontSize:10, color:hbcp.inkLight}}>{sp.date}</div>
                                </a>
                              </li>
                            ))}
                          </ul>
                        )}
                        {/* セクション全部見るリンク */}
                        {g.url && (
                          <a href={g.url} style={{display:'inline-flex', alignItems:'center', gap:6, marginTop:'auto', paddingTop:10, fontFamily:fontJP, fontSize:11.5, fontWeight:700, color:g.accent, textDecoration:'none'}}>
                            {g.name} の記事をすべて見る ({g.count}) <span style={{fontFamily:fontEN}}>→</span>
                          </a>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </section>
            );
          })()}

          {/* ===== Data Stories — 数字／統計／調査系の編集帯（Quartz 風 dark band） ===== */}
          {isFeaturedView && !data.top_products && (() => { /* データストーリーは導入事例(top_products有)で非表示 (Setoguchi #42-2) */
            // 数字・統計・割合・調査キーワードを含む記事を抽出（簡易ヒューリスティック）
            const isData = (p) => {
              const text = `${p.title || ''} ${p.excerpt || ''}`;
              return /[0-9]{2,}\s*[%％件人円]|統計|データ|調査|分析|ベンチマーク|レポート|ランキング|％/.test(text);
            };
            const dataPosts = (posts || []).filter( isData ).slice(0, 3);
            if ( dataPosts.length < 2 ) return null;
            return (
              <section className="hb-arc-data" style={{padding:'52px 32px 60px', background:'#0A2846', color:'#FFFFFF', borderTop:`1px solid ${hbcp.ink}`}}>
                <div style={{maxWidth:MAXW, margin:'0 auto'}}>
                  <div style={{display:'flex', alignItems:'baseline', justifyContent:'space-between', borderBottom:'1px solid rgba(255,255,255,.18)', paddingBottom:10, marginBottom:28, flexWrap:'wrap', gap:12}}>
                    <div>
                      <div style={{fontFamily:fontJP, fontSize:11, fontWeight:700, color:'#7DD3FC', marginBottom:6}}>● データストーリー</div>
                      <h2 style={{fontFamily:fontSerif, fontWeight:700, fontSize:'clamp(22px, 2.4vw, 28px)', letterSpacing:'.04em', margin:0, color:'#fff'}}>数字で読み解く</h2>
                    </div>
                    <p style={{fontFamily:fontJP, fontSize:13, lineHeight:1.7, color:'rgba(255,255,255,.7)', margin:0, maxWidth:520}}>
                      経営判断・業務改善のための「数字」を起点にした記事。統計・調査・ベンチマーク・実装結果のレポートを集めています。
                    </p>
                  </div>
                  <div className="hb-data-grid" style={{display:'grid', gridTemplateColumns:`repeat(${dataPosts.length}, 1fr)`, gap:24}}>
                    {dataPosts.map( (p, i) => (
                      <a key={p.id} href={p.permalink} style={{display:'flex', flexDirection:'column', gap:10, textDecoration:'none', color:'#fff', borderTop:'1px solid rgba(255,255,255,.18)', paddingTop:14}}>
                        <div style={{fontFamily:fontEN, fontWeight:300, fontSize:38, lineHeight:1, color:'#7DD3FC'}}>{String(i+1).padStart(2,'0')}</div>
                        {p.cat && <div style={{fontFamily:fontENSans, fontSize:9, letterSpacing:'.28em', fontWeight:700, color:'rgba(255,255,255,.65)', textTransform:'uppercase'}}>{p.cat}</div>}
                        <h3 style={{fontFamily:fontSerif, fontWeight:700, fontSize:17, lineHeight:1.35, letterSpacing:'.04em', margin:'2px 0 4px', color:'#fff', display:'-webkit-box', WebkitLineClamp:4, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{p.title}</h3>
                        {p.excerpt && (
                          <p style={{fontFamily:fontJP, fontSize:12, lineHeight:1.8, color:'rgba(255,255,255,.7)', margin:0, display:'-webkit-box', WebkitLineClamp:4, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{p.excerpt}</p>
                        )}
                        <div style={{display:'flex', alignItems:'center', gap:10, marginTop:'auto', paddingTop:10, fontFamily:fontMono, fontSize:11, color:'rgba(255,255,255,.55)'}}>
                          <span>{p.date}</span>
                          <span style={{flex:1, height:1, background:'rgba(255,255,255,.15)'}}/>
                          <span style={{fontFamily:fontJP, fontSize:11.5, fontWeight:700, color:'#7DD3FC'}}>続きを読む <span style={{fontFamily:fontEN}}>→</span></span>
                        </div>
                      </a>
                    ))}
                  </div>
                </div>
              </section>
            );
          })()}

          {/* ===== 入門ガイド (page 1 / admin で設定された場合のみ) ===== */}
          {isFeaturedView && Array.isArray(data.beginner) && data.beginner.length >= 3 && (
            <section className="hb-arc-beginner" style={{padding:'56px 32px 64px', background:'#FAF7F2', borderTop:`1px solid ${hbcp.line}`}}>
              <div style={{maxWidth:MAXW, margin:'0 auto'}}>
                <div style={{display:'flex', alignItems:'baseline', justifyContent:'space-between', borderBottom:`1px solid ${hbcp.ink}`, paddingBottom:10, marginBottom:24, gap:24, flexWrap:'wrap'}}>
                  <div>
                    <div style={{fontFamily:fontJP, fontSize:11, fontWeight:700, color:'#A65A38', marginBottom:6}}>● 入門ガイド</div>
                    <h2 style={{fontFamily:fontSerif, fontWeight:700, fontSize:'clamp(22px, 2.4vw, 28px)', letterSpacing:'.04em', margin:0, color:hbcp.ink}}>
                      まず、ここから読む
                    </h2>
                  </div>
                  <p style={{fontFamily:fontJP, fontSize:13, lineHeight:1.7, color:hbcp.inkSoft, margin:0, maxWidth:520}}>
                    新任の担当者・はじめての読者向けに、編集部が選んだ「最初の一冊」シリーズ。基礎を 1 本ずつ抑えていけば全体像が掴めます。
                  </p>
                </div>
                <ol className="hb-beginner-grid" style={{display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:24, listStyle:'none', margin:0, padding:0}}>
                  {data.beginner.slice(0, 6).map( (p, i) => (
                    <li key={p.id} style={{display:'flex', flexDirection:'column', gap:6, background:'#fff', border:`1px solid ${hbcp.line}`, padding:'18px 18px'}}>
                      <a href={p.permalink} style={{display:'flex', flexDirection:'column', gap:6, textDecoration:'none', color:hbcp.ink}}>
                        <div style={{display:'flex', alignItems:'baseline', gap:10}}>
                          <span style={{fontFamily:fontEN, fontWeight:300, fontSize:30, lineHeight:1, color:'#A65A38'}}>
                            {String(i+1).padStart(2,'0')}
                          </span>
                          {p.cat && <span style={{fontFamily:fontJP, fontSize:10.5, fontWeight:700, color:hbcp.inkLight}}>{p.cat}</span>}
                        </div>
                        <h3 style={{fontFamily:fontSerif, fontWeight:700, fontSize:15, lineHeight:1.35, letterSpacing:'.04em', margin:'4px 0 4px', color:hbcp.ink, display:'-webkit-box', WebkitLineClamp:4, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{p.title}</h3>
                        {p.excerpt && (
                          <p style={{fontFamily:fontJP, fontSize:11.5, lineHeight:1.7, color:hbcp.inkSoft, margin:'0 0 4px', display:'-webkit-box', WebkitLineClamp:3, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{p.excerpt}</p>
                        )}
                        <div style={{fontFamily:fontMono, fontSize:10, color:hbcp.inkLight, marginTop:'auto', paddingTop:6}}>{p.date}</div>
                      </a>
                    </li>
                  ))}
                </ol>
              </div>
            </section>
          )}

          {/* ===== 事業部別ソリューション (page 1 のみ / 3 col: DX / 研修 / 会計コンサル) ===== */}
          {false && isFeaturedView && Array.isArray(data.solutions) && data.solutions.length > 0 && ( /* 事業部別ソリューション撤去 (Setoguchi #42-2) */
            <section className="hb-arc-solutions" style={{padding:'56px 32px 64px', background:hbcp.white, borderTop:`1px solid ${hbcp.ink}`}}>
              <div style={{maxWidth:MAXW, margin:'0 auto'}}>
                <div style={{display:'flex', alignItems:'baseline', justifyContent:'space-between', borderBottom:`1px solid ${hbcp.ink}`, paddingBottom:10, marginBottom:28, gap:24, flexWrap:'wrap'}}>
                  <div>
                    <div style={{fontFamily:fontJP, fontSize:11, fontWeight:700, color:hbcp.blue, marginBottom:6}}>● 弊社の事業部から</div>
                    <h2 style={{fontFamily:fontSerif, fontWeight:700, fontSize:'clamp(22px, 2.4vw, 28px)', letterSpacing:'.04em', margin:0, color:hbcp.ink}}>
                      事業部別ソリューション
                    </h2>
                  </div>
                  <p style={{fontFamily:fontJP, fontSize:13, lineHeight:1.7, color:hbcp.inkSoft, margin:0, maxWidth:520}}>
                    はてなベースは DX・研修・会計コンサルの 3 つの事業部で、御社のバックオフィスを伸び代に変えるパートナーシップを提供しています。
                  </p>
                </div>
                <div className="hb-solutions-grid" style={{display:'grid', gridTemplateColumns:`repeat(${data.solutions.length}, 1fr)`, gap:20}}>
                  {data.solutions.map( sol => (
                    <div key={sol.key}
                         style={{
                           display:'flex', flexDirection:'column',
                           background:sol.accent, color:'#fff',
                           padding:'22px 22px 20px',
                           minHeight:380,
                         }}>
                      <div style={{borderTop:'2px solid rgba(255,255,255,.55)', paddingTop:8, marginBottom:14}}>
                        <div style={{fontFamily:fontJP, fontSize:11, fontWeight:700, color:'rgba(255,255,255,.85)', marginBottom:4}}>{sol.subtitle}</div>
                        <h3 style={{fontFamily:fontSerif, fontWeight:700, fontSize:'clamp(18px, 1.6vw, 22px)', lineHeight:1.25, letterSpacing:'.04em', margin:0, color:'#fff'}}>
                          {sol.name}
                        </h3>
                      </div>
                      <p style={{fontFamily:fontJP, fontSize:12.5, lineHeight:1.75, color:'rgba(255,255,255,.85)', margin:'0 0 16px'}}>{sol.desc}</p>

                      {/* 関連記事 3 件 */}
                      {sol.posts && sol.posts.length > 0 && (
                        <div style={{borderTop:'1px solid rgba(255,255,255,.3)', paddingTop:12, marginBottom:14, flex:'1 1 auto'}}>
                          <div style={{fontFamily:fontJP, fontSize:10.5, fontWeight:700, color:'rgba(255,255,255,.85)', marginBottom:8}}>● 関連記事</div>
                          <ul style={{listStyle:'none', margin:0, padding:0}}>
                            {sol.posts.map( (sp, i) => (
                              <li key={sp.id} style={{padding:'5px 0', borderBottom: i === sol.posts.length-1 ? 'none' : '1px solid rgba(255,255,255,.18)'}}>
                                <a href={sp.permalink} style={{display:'flex', gap:8, textDecoration:'none', color:'#fff'}}>
                                  <span style={{flex:'0 0 16px', fontFamily:fontEN, fontSize:12, color:'rgba(255,255,255,.7)'}}>{String(i+1).padStart(2,'0')}</span>
                                  <span style={{flex:1, fontFamily:fontSerif, fontWeight:500, fontSize:12, lineHeight:1.4, display:'-webkit-box', WebkitLineClamp:3, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{sp.title}</span>
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                      {/* CTA: LP / Term URL */}
                      <div style={{marginTop:'auto', display:'flex', flexDirection:'column', gap:8}}>
                        {sol.lp_url && (
                          <a href={sol.lp_url} style={{display:'inline-flex', alignItems:'center', gap:6, fontFamily:fontJP, fontSize:11.5, fontWeight:700, color:'#fff', textDecoration:'none', paddingBottom:4, borderBottom:'1px solid #fff'}}>
                            事業部のサービスを見る <span style={{fontFamily:fontEN}}>→</span>
                          </a>
                        )}
                        {sol.term_url && (
                          <a href={sol.term_url} style={{display:'inline-flex', alignItems:'center', gap:6, fontFamily:fontJP, fontSize:11, color:'rgba(255,255,255,.7)', textDecoration:'none'}}>
                            関連記事をすべて見る <span style={{fontFamily:fontEN}}>→</span>
                          </a>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          )}

          {/* ===== 業界別事例 (page 1 / admin で設定された場合のみ) ===== */}
          {isFeaturedView && Array.isArray(data.industry) && data.industry.length >= 2 && (
            <section className="hb-arc-industry" style={{padding:'56px 32px 64px', background:hbcp.white, borderTop:`1px solid ${hbcp.line}`}}>
              <div style={{maxWidth:MAXW, margin:'0 auto'}}>
                <div style={{display:'flex', alignItems:'baseline', justifyContent:'space-between', borderBottom:`1px solid ${hbcp.ink}`, paddingBottom:10, marginBottom:24, gap:24, flexWrap:'wrap'}}>
                  <div>
                    <div style={{fontFamily:fontJP, fontSize:11, fontWeight:700, color:'#5C2B45', marginBottom:6}}>● 業界別事例</div>
                    <h2 style={{fontFamily:fontSerif, fontWeight:700, fontSize:'clamp(22px, 2.4vw, 28px)', letterSpacing:'.04em', margin:0, color:hbcp.ink}}>
                      現場で起きた、リアルな事例
                    </h2>
                  </div>
                  <p style={{fontFamily:fontJP, fontSize:13, lineHeight:1.7, color:hbcp.inkSoft, margin:0, maxWidth:520}}>
                    実際の導入・改善・運用の現場で何が起きたか。業種・規模ごとのケーススタディを集約しています。
                  </p>
                </div>
                <ol className="hb-industry-grid" style={{display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:0, listStyle:'none', margin:0, padding:0}}>
                  {data.industry.slice(0, 6).map( (p, i, arr) => (
                    <li key={p.id} style={{padding:`14px ${i % 3 === 2 ? 0 : 22}px ${i >= 3 ? 0 : 14}px ${i % 3 === 0 ? 0 : 22}px`, borderRight: i % 3 === 2 ? 'none' : `1px solid ${hbcp.line}`, borderTop: `2px solid ${'#5C2B45'}`, borderBottom: i < arr.length - 3 ? `1px solid ${hbcp.line}` : 'none'}}>
                      <a href={p.permalink} style={{display:'flex', flexDirection:'column', gap:6, textDecoration:'none', color:hbcp.ink}}>
                        <div style={{display:'flex', alignItems:'baseline', gap:10}}>
                          <span style={{fontFamily:fontEN, fontWeight:300, fontSize:24, lineHeight:1, color:'#5C2B45'}}>CASE {String(i+1).padStart(2,'0')}</span>
                          {p.cat && <span style={{fontFamily:fontJP, fontSize:10.5, fontWeight:700, color:hbcp.inkLight}}>· {p.cat}</span>}
                        </div>
                        <h3 style={{fontFamily:fontSerif, fontWeight:700, fontSize:15, lineHeight:1.35, letterSpacing:'.04em', margin:'4px 0 2px', color:hbcp.ink, display:'-webkit-box', WebkitLineClamp:4, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{p.title}</h3>
                        {p.excerpt && (
                          <p style={{fontFamily:fontJP, fontSize:11.5, lineHeight:1.7, color:hbcp.inkSoft, margin:'2px 0 4px', display:'-webkit-box', WebkitLineClamp:3, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{p.excerpt}</p>
                        )}
                        <div style={{fontFamily:fontMono, fontSize:10, color:hbcp.inkLight}}>{p.date}</div>
                      </a>
                    </li>
                  ))}
                </ol>
              </div>
            </section>
          )}

          {/* (旧: テーマ別に深く読む — 事業部別ソリューションと機能重複のため撤去 2026-05-06) */}

          {/* ===== 編集部の選 (page 1 / admin で設定された場合のみ) ===== */}
          {isFeaturedView && Array.isArray(data.editor) && data.editor.length >= 3 && (
            <section className="hb-arc-editor" style={{padding:'56px 32px 64px', background:'#FAF7F2', borderTop:`1px solid ${hbcp.line}`}}>
              <div style={{maxWidth:MAXW, margin:'0 auto'}}>
                <div style={{display:'flex', alignItems:'baseline', justifyContent:'space-between', borderBottom:`1px solid ${hbcp.ink}`, paddingBottom:10, marginBottom:24, gap:24, flexWrap:'wrap'}}>
                  <div>
                    <div style={{fontFamily:fontJP, fontSize:11, fontWeight:700, color:hbcp.blue, marginBottom:6}}>● 編集部の選</div>
                    <h2 style={{fontFamily:fontSerif, fontWeight:700, fontSize:'clamp(22px, 2.4vw, 28px)', letterSpacing:'.04em', margin:0, color:hbcp.ink}}>
                      編集部が、もう一度読んでほしい記事
                    </h2>
                  </div>
                  <p style={{fontFamily:fontJP, fontSize:13, lineHeight:1.7, color:hbcp.inkSoft, margin:0, maxWidth:520}}>
                    話題の旬を超え、読み返す価値のある記事を編集部が選びました。じっくり腰を据えて読みたい一本を、ここから。
                  </p>
                </div>
                <div className="hb-editor-grid" style={{display:'grid', gridTemplateColumns:`minmax(0, 2fr) minmax(0, 1fr)`, gap:36, alignItems:'start'}}>
                  {/* 左: 大ヒーロー */}
                  {data.editor[0] && (
                    <a href={data.editor[0].permalink} style={{display:'flex', flexDirection:'column', textDecoration:'none', color:hbcp.ink, gap:14}}>
                      {data.editor[0].thumbnail && (
                        <div style={{aspectRatio:'16 / 9', overflow:'hidden', background:hbcp.paper}}>
                          <img src={data.editor[0].thumbnail} alt="" style={{width:'100%', height:'100%', objectFit:'cover', display:'block'}}/>
                        </div>
                      )}
                      <div>
                        {data.editor[0].cat && <div style={{fontFamily:fontJP, fontSize:11, fontWeight:700, color:hbcp.blue, marginBottom:6}}>{data.editor[0].cat} ／ 編集長の一冊</div>}
                        <h3 style={{fontFamily:fontSerif, fontWeight:800, fontSize:'clamp(20px, 2vw, 26px)', lineHeight:1.3, letterSpacing:'.04em', margin:'0 0 8px', display:'-webkit-box', WebkitLineClamp:4, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{data.editor[0].title}</h3>
                        {data.editor[0].excerpt && (
                          <p style={{fontFamily:fontJP, fontSize:13, lineHeight:1.85, color:hbcp.inkSoft, margin:'0 0 8px', display:'-webkit-box', WebkitLineClamp:4, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{data.editor[0].excerpt}</p>
                        )}
                        <div style={{fontFamily:fontMono, fontSize:11, color:hbcp.inkLight}}>{data.editor[0].date}</div>
                      </div>
                    </a>
                  )}
                  {/* 右: 縦積みリスト */}
                  {data.editor.length > 1 && (
                    <ul style={{listStyle:'none', margin:0, padding:0, borderTop:`1px solid ${hbcp.line}`}}>
                      {data.editor.slice(1, 5).map( (p, i) => (
                        <li key={p.id} style={{padding:'12px 0', borderBottom:`1px solid ${hbcp.line}`}}>
                          <a href={p.permalink} style={{display:'flex', gap:10, textDecoration:'none', color:hbcp.ink}}>
                            <span style={{flex:'0 0 28px', fontFamily:fontEN, fontWeight:300, fontSize:20, lineHeight:1.1, color:hbcp.blue}}>{String(i+2).padStart(2,'0')}</span>
                            <div style={{flex:1}}>
                              {p.cat && <div style={{fontFamily:fontJP, fontSize:10, fontWeight:700, color:hbcp.inkLight, marginBottom:3}}>{p.cat}</div>}
                              <h4 style={{fontFamily:fontSerif, fontWeight:700, fontSize:13.5, lineHeight:1.4, margin:'0 0 3px', display:'-webkit-box', WebkitLineClamp:3, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{p.title}</h4>
                              <div style={{fontFamily:fontMono, fontSize:10, color:hbcp.inkLight}}>{p.date}</div>
                            </div>
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </section>
          )}

          {/* ===== よく読まれている記事 TOP 8 (page 1 のみ / wp-admin で手動キュレーション) ===== */}
          {isFeaturedView && Array.isArray(data.popular) && data.popular.length >= 4 && (
            <section className="hb-arc-popular" style={{padding:'56px 32px 0', background:hbcp.white, borderTop:`1px solid ${hbcp.ink}`}}>
              <div style={{maxWidth:MAXW, margin:'0 auto'}}>
                <div style={{display:'flex', alignItems:'baseline', justifyContent:'space-between', borderBottom:`1px solid ${hbcp.ink}`, paddingBottom:10, marginBottom:24, gap:24, flexWrap:'wrap'}}>
                  <div>
                    <div style={{fontFamily:fontJP, fontSize:11, fontWeight:700, color:hbcp.blue, marginBottom:6}}>● 読者の関心</div>
                    <h2 style={{fontFamily:fontSerif, fontWeight:700, fontSize:'clamp(22px, 2.4vw, 28px)', letterSpacing:'.04em', margin:0, color:hbcp.ink}}>
                      よく読まれている記事
                    </h2>
                  </div>
                  <p style={{fontFamily:fontJP, fontSize:13, lineHeight:1.7, color:hbcp.inkSoft, margin:0, maxWidth:520}}>
                    過去 30 日でアクセスの多かった記事を 8 本セレクト。「今、現場で気になっているテーマ」のサインです。
                  </p>
                </div>
                <ol className="hb-popular-grid" style={{display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gap:20, listStyle:'none', margin:0, padding:0}}>
                  {data.popular.slice(0, 8).map( (p, i) => (
                    <li key={p.id} style={{borderTop:`1px solid ${hbcp.line}`, paddingTop:14}}>
                      <a href={p.permalink} style={{display:'flex', flexDirection:'column', gap:6, textDecoration:'none', color:hbcp.ink}}>
                        <div style={{display:'flex', alignItems:'baseline', gap:10, marginBottom:4}}>
                          <span style={{fontFamily:fontEN, fontWeight:300, fontSize:34, lineHeight:1, color:hbcp.blue}}>
                            {String(i+1).padStart(2,'0')}
                          </span>
                          {p.cat && <span style={{fontFamily:fontJP, fontSize:10.5, fontWeight:700, color:hbcp.inkLight}}>{p.cat}</span>}
                        </div>
                        <h3 style={{fontFamily:fontSerif, fontWeight:700, fontSize:14, lineHeight:1.4, letterSpacing:'.04em', margin:'0 0 4px', display:'-webkit-box', WebkitLineClamp:4, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{p.title}</h3>
                        {p.excerpt && (
                          <p style={{fontFamily:fontJP, fontSize:11.5, lineHeight:1.7, color:hbcp.inkSoft, margin:'0 0 4px', display:'-webkit-box', WebkitLineClamp:3, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{p.excerpt}</p>
                        )}
                        <div style={{fontFamily:fontMono, fontSize:10, color:hbcp.inkLight}}>{p.date}</div>
                      </a>
                    </li>
                  ))}
                </ol>
              </div>
            </section>
          )}

          {/* ===== タグで探す (Blog 専用 / 最下段 / Top 10 + モーダル全件) =====
              データソース: サイト全体の blog-tag タクソノミー (count DESC, hide_empty)。
              タグ ≠ カテゴリ (blog-category)。混ぜない。
              ・Top 10 を画面に表示
              ・「キーワード一覧」ボタンで全タグをモーダルで開く */}
          {/* ===== タグ別記事リスト (Blog 専用 / page 1 のみ) =====
              by_tag_sections = PHP が 6 タグ分の最新 4 件を注入した配列。
              「タグで探す」チップの直下に配置し、タグ単位の記事群を閲覧可能にする。 */}
          {isBlog && isFeaturedView && Array.isArray(data.by_tag_sections) && data.by_tag_sections.length > 0 && (
            <section className="hb-arc-bytag" style={{background:hbcp.white, borderTop:`1px solid ${hbcp.line}`}}>
              <div style={{maxWidth:MAXW, margin:'0 auto', padding:'0 32px'}}>
                {data.by_tag_sections.map( (tg, ti) => (
                  <div key={tg.slug} style={{paddingTop:48, paddingBottom:48, borderBottom: ti < data.by_tag_sections.length - 1 ? `1px solid ${hbcp.line}` : 'none'}}>
                    {/* タグ見出し行 */}
                    <div style={{display:'flex', alignItems:'baseline', justifyContent:'space-between', gap:16, marginBottom:22, borderBottom:`2px solid ${hbcp.ink}`, paddingBottom:10}}>
                      <div style={{display:'flex', alignItems:'baseline', gap:10}}>
                        <span style={{fontFamily:fontEN, fontSize:14, fontWeight:700, color:hbcp.blue}}>#</span>
                        <h2 style={{fontFamily:fontSerif, fontWeight:700, fontSize:'clamp(18px, 1.8vw, 22px)', letterSpacing:'.04em', margin:0, color:hbcp.ink}}>{tg.name}</h2>
                        {tg.count > 0 && <span style={{fontFamily:fontMono, fontSize:11, color:hbcp.inkLight}}>{tg.count}件</span>}
                      </div>
                      {tg.url && (
                        <a href={tg.url} style={{fontFamily:fontJP, fontSize:12, fontWeight:700, color:hbcp.blue, textDecoration:'none', whiteSpace:'nowrap', borderBottom:`1px solid ${hbcp.blue}`, paddingBottom:2}}>
                          すべて見る →
                        </a>
                      )}
                    </div>
                    {/* 記事 4 件グリッド */}
                    <div className="hb-tag-section-grid" style={{display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gap:'0 24px'}}>
                      {tg.posts.slice(0, 4).map( (p, pi) => (
                        <a key={p.id} href={p.permalink} className="hb-arc-tagcard" style={{display:'flex', flexDirection:'column', gap:0, textDecoration:'none', color:hbcp.ink, borderLeft: pi > 0 ? `1px solid ${hbcp.line}` : 'none', paddingLeft: pi > 0 ? 24 : 0}}>
                          <div className="hb-arc-tagcard__media" style={{aspectRatio:'16/9', overflow:'hidden', background:hbcp.paper}}>
                            {p.thumbnail
                              ? <img src={p.thumbnail} alt="" loading="lazy" className="hb-arc-tagcard__img" style={{width:'100%', height:'100%', objectFit:'cover', display:'block'}}/>
                              : <div style={{width:'100%', height:'100%', display:'grid', placeItems:'center', color:hbcp.inkLight, fontFamily:fontEN, fontSize:20}}>—</div>}
                          </div>
                          {p.cat && <div className="hb-arc-tagcard__kicker" style={{fontFamily:fontENSans, fontSize:9, letterSpacing:'.22em', fontWeight:700, color:hbcp.blue, textTransform:'uppercase', marginTop:4}}>{p.cat}</div>}
                          <h3 className="hb-arc-tagcard__title" style={{fontFamily:fontSerif, fontWeight:700, fontSize:13.5, lineHeight:1.45, letterSpacing:'.04em', margin:'2px 0 0', display:'-webkit-box', WebkitLineClamp:4, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{p.title}</h3>
                          {/* ArticleDeck (記事要約 / リード文) — タイトル下 */}
                          {p.deck && <p className="hb-arc-tagcard__deck" style={{fontFamily:fontJP, fontSize:11.5, lineHeight:1.65, color:hbcp.inkSoft, margin:'4px 0 0'}}>{p.deck}</p>}
                          <div className="hb-arc-tagcard__date" style={{fontFamily:fontMono, fontSize:10, color:hbcp.inkLight, marginTop:'auto', paddingTop:6}}>{p.date}</div>
                        </a>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )}

          {isBlog && (() => {
            const allTags = top_tags || [];
            const top10 = allTags.slice(0, 10);
            if (top10.length === 0) return null;
            return (
            <section className="hb-arc-tagcloud" style={{padding:'56px 32px 64px', background:hbcp.paper, borderTop:`1px solid ${hbcp.line}`}}>
              <div style={{maxWidth:MAXW, margin:'0 auto'}}>
                <div style={{display:'flex', alignItems:'baseline', justifyContent:'space-between', marginBottom:20, gap:24, flexWrap:'wrap'}}>
                  <div>
                    <div style={{fontFamily:fontJP, fontSize:11, fontWeight:700, color:hbcp.blue, marginBottom:6}}>● タグ</div>
                    <h2 style={{fontFamily:fontSerif, fontWeight:700, fontSize:'clamp(22px, 2.4vw, 28px)', letterSpacing:'.04em', margin:'0 0 4px', color:hbcp.ink}}>タグで探す</h2>
                  </div>
                  <p style={{fontFamily:fontJP, fontSize:13, lineHeight:1.7, color:hbcp.inkSoft, margin:0, maxWidth:520}}>
                    記事に紐付けたタグから、関連する記事を一気に読めます。下に並ぶのは記事数の多い上位 10 件のタグです。
                  </p>
                </div>
                <div style={{display:'flex', flexWrap:'wrap', gap:8, alignItems:'center'}}>
                  {top10.map( k => (
                    <a key={k.name} href={k.url || '#'}
                       style={{
                         display:'inline-flex', alignItems:'center', gap:6,
                         padding:'8px 14px', background:'#fff', border:`1px solid ${hbcp.line}`,
                         textDecoration:'none', color:hbcp.ink, fontFamily:fontJP, fontSize:13, fontWeight:500,
                       }}>
                      <span style={{color:hbcp.blue, fontFamily:fontEN, fontSize:12, fontWeight:600}}>#</span>
                      {k.name}
                      {k.count != null && <span style={{fontFamily:fontMono, fontSize:11, color:hbcp.inkLight}}>{k.count}</span>}
                    </a>
                  ))}
                  {allTags.length > 10 && (
                    <button type="button" onClick={() => setTagModalOpen(true)}
                       style={{
                         display:'inline-flex', alignItems:'center', gap:6,
                         padding:'8px 14px', background:hbcp.ink, border:`1px solid ${hbcp.ink}`,
                         color:'#fff', fontFamily:fontJP, fontSize:13, fontWeight:600, cursor:'pointer',
                       }}>
                      キーワード一覧（全 {allTags.length} 件）<span style={{fontFamily:fontEN}}>→</span>
                    </button>
                  )}
                </div>
              </div>

              {/* モーダル: 全タグ一覧 */}
              {tagModalOpen && (
                <div onClick={() => setTagModalOpen(false)}
                     style={{
                       position:'fixed', inset:0, background:'rgba(11, 28, 72, 0.62)',
                       display:'flex', alignItems:'center', justifyContent:'center',
                       padding:'24px', zIndex:9000,
                     }}>
                  <div onClick={(e) => e.stopPropagation()}
                       style={{
                         background:'#fff', maxWidth:880, width:'100%', maxHeight:'80vh',
                         overflowY:'auto', padding:'40px 36px', position:'relative',
                         boxShadow:'0 12px 60px rgba(0,0,0,0.25)',
                       }}>
                    <button type="button" onClick={() => setTagModalOpen(false)}
                       aria-label="閉じる"
                       style={{
                         position:'absolute', top:16, right:16, background:'transparent',
                         border:'none', fontSize:28, lineHeight:1, color:hbcp.ink, cursor:'pointer',
                       }}>×</button>
                    <div style={{fontFamily:fontJP, fontSize:11, fontWeight:700, color:hbcp.blue, marginBottom:6}}>● タグ一覧</div>
                    <h3 style={{fontFamily:fontSerif, fontWeight:700, fontSize:24, letterSpacing:'.04em', margin:'0 0 18px', color:hbcp.ink}}>キーワード一覧（全 {allTags.length} 件）</h3>
                    <div style={{display:'flex', flexWrap:'wrap', gap:8}}>
                      {allTags.map(k => (
                        <a key={k.name} href={k.url || '#'}
                           style={{
                             display:'inline-flex', alignItems:'center', gap:6,
                             padding:'8px 14px', background:hbcp.paper, border:`1px solid ${hbcp.line}`,
                             textDecoration:'none', color:hbcp.ink, fontFamily:fontJP, fontSize:13, fontWeight:500,
                           }}>
                          <span style={{color:hbcp.blue, fontFamily:fontEN, fontSize:12, fontWeight:600}}>#</span>
                          {k.name}
                          {k.count != null && <span style={{fontFamily:fontMono, fontSize:11, color:hbcp.inkLight}}>{k.count}</span>}
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </section>
            );
          })()}

        </>
        )}

        {/* Bottom CTA (アーカイブ別オプション。HB_ARCHIVE.cta_bottom が指定された場合のみ表示)
            achievements では「ソリューション一覧はこちら」(/lp/) への動線として利用。 */}
        {data.cta_bottom && data.cta_bottom.url && (
          <section className="hb-arc-cta-bottom" style={{padding:'72px 32px 56px', background:hbcp.white, borderTop:`1px solid ${hbcp.line}`}}>
            <div style={{maxWidth:880, margin:'0 auto', textAlign:'center'}}>
              <div style={{fontFamily:fontENSans, fontSize:11, letterSpacing:'.32em', fontWeight:700, color:hbcp.blue, marginBottom:14}}>
                ● {(data.cta_bottom.eyebrow || 'ALL SOLUTIONS').toUpperCase()}
              </div>
              {data.cta_bottom.title && (
                <h2 style={{fontFamily:fontSerif, fontWeight:700, fontSize:'clamp(22px, 2.4vw, 28px)', lineHeight:1.4, margin:'0 0 14px', color:hbcp.ink}}>
                  {data.cta_bottom.title}
                </h2>
              )}
              {data.cta_bottom.lead && (
                <p style={{fontSize:13.5, lineHeight:1.85, color:hbcp.inkSoft, margin:'0 auto 26px', maxWidth:640}}>
                  {data.cta_bottom.lead}
                </p>
              )}
              <a href={data.cta_bottom.url}
                 style={{display:'inline-flex', alignItems:'center', gap:10, padding:'14px 30px', background:hbcp.ink, color:'#fff', textDecoration:'none', fontFamily:fontJP, fontSize:14, fontWeight:700, letterSpacing:'.01em'}}>
                {data.cta_bottom.label || 'ソリューション一覧はこちら'}
                <span style={{fontFamily:fontEN}}>→</span>
              </a>
            </div>
          </section>
        )}

        {/* End CTA */}
        <section className="hb-arc-endcta" style={{display:'none'}}> {/* About This Company / 攻めのバックオフィス ブロック撤去 (Setoguchi #42-2b/#44-4) */}
          <div style={{maxWidth:880, margin:'0 auto', textAlign:'center'}}>
            <div style={{fontFamily:fontENSans, fontSize:11, letterSpacing:'.32em', color:hbcp.blue, marginBottom:14}}>● ABOUT THIS COMPANY</div>
            <h2 style={{fontFamily:fontSerif, fontWeight:700, fontSize:'clamp(24px, 2.8vw, 32px)', lineHeight:1.4, margin:'0 0 18px'}}>
              攻めのバックオフィスで、経済OSをアップデート。
            </h2>
            <p style={{fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 28px'}}>
              DX × 会計 × AI の交点で、戦略設計から現場の導入・運用・改善まで。<br/>
              スタートアップ・中小企業のバックオフィスを伸び代に変えるパートナー。
            </p>
            <div style={{display:'inline-flex', gap:14}}>
              <a href={`${HB_BASE}/contact`} style={{padding:'14px 26px', background:hbcp.blue, color:'#fff', textDecoration:'none', fontFamily:fontJP, fontSize:14, fontWeight:700}}>
                無料相談を予約する <span style={{fontFamily:fontEN}}>→</span>
              </a>
              <a href={HB_BASE} style={{padding:'14px 26px', background:'transparent', color:hbcp.ink, border:`1px solid ${hbcp.ink}`, textDecoration:'none', fontFamily:fontJP, fontSize:14, fontWeight:600}}>
                サービスを見る <span style={{fontFamily:fontEN}}>↗</span>
              </a>
            </div>
          </div>
        </section>

        {/* Responsive overrides */}
        <style>{`
          @media (max-width: 1024px) {
            .hb-hero-strip { grid-template-columns: 1fr !important; gap: 48px !important; }
            .hb-tag-section-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 24px !important; }
            .hb-tag-section-grid > a { border-left: none !important; padding-left: 0 !important; border-top: 1px solid #e5e5e5 !important; padding-top: 16px !important; }
            .hb-tag-section-grid > a:nth-child(1),
            .hb-tag-section-grid > a:nth-child(2) { border-top: none !important; padding-top: 0 !important; }
            .hb-grid-4 { grid-template-columns: repeat(2, 1fr) !important; }
            .hb-archive-products-grid { grid-template-columns: repeat(3, 1fr) !important; }
          }
          @media (max-width: 720px) {
            .hb-archive-products-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 14px !important; }
            .hb-archive-products { padding: 36px 16px 44px !important; }
          }
          .hb-archive-product-card:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(0,0,0,.08); }
          @media (max-width: 600px) {
            .hb-tag-section-grid { grid-template-columns: 1fr 1fr !important; gap: 12px !important; }
            /* The Economist スタイル: 1 列ではなく 2 列を維持 */
            .hb-grid-4 { grid-template-columns: 1fr 1fr !important; gap: 28px 12px !important; }
          }

          /* ===== Mobile (≤640px) — The Economist 風: マストヘッド削除、カテゴリ最上段 ===== */
          @media (max-width: 640px) {
            /* ===== 新着記事グリッド (.hb-grid-4) — Economist 風 階層的レイアウト =====
               #1: 縦積み hero (image-TOP 大 + title + 短い dek)
               #2-#3: 縦積みの row (title 左 / image 右 110px + excerpt 2 行)
               #4+: 2x2 paired grid (image-TOP + title only, no excerpt)
               variant-d-loader.php の汎用 div[style*="repeat(4, 1fr)"] override より
               specificity を上げるため html prefix + [style] attribute selector。 */
            html .hb-grid-4[style] { grid-template-columns: 1fr 1fr !important; gap: 5px !important; }

            /* #1 hero — full width (両カラム占有), image-TOP, title, dek */
            .hb-grid-4 > a:nth-child(1) {
              grid-column: 1 / -1 !important;
              display: flex !important; flex-direction: column !important;
              gap: 8px !important;
              padding-bottom: 16px !important; border-bottom: 1px solid #e5e5e5 !important;
            }
            .hb-grid-4 > a:nth-child(1) > div:first-child { aspect-ratio: 16/9 !important; width: 100% !important; }
            .hb-grid-4 > a:nth-child(1) > div:nth-child(2) { font-size: 9.5px !important; letter-spacing: .22em !important; margin-top: 4px !important; }
            .hb-grid-4 > a:nth-child(1) > h3 { font-size: 17px !important; line-height: 1.35 !important; margin: 2px 0 4px !important; -webkit-line-clamp: unset !important; display: block !important; overflow: visible !important; }
            .hb-grid-4 > a:nth-child(1) > p { display: -webkit-box !important; -webkit-line-clamp: 2 !important; -webkit-box-orient: vertical !important; overflow: hidden; font-size: 12.5px !important; line-height: 1.6 !important; color: #555 !important; margin: 0 !important; }
            .hb-grid-4 > a:nth-child(1) > div[style*="fontMono"], .hb-grid-4 > a:nth-child(1) > div[style*="font-family: ui-monospace"] { font-size: 10.5px !important; padding-top: 6px !important; }

            /* #2 / #3 — full width row (title 左 + image 右 110px / 内部 4 行 × 2 列 grid) */
            .hb-grid-4 > a:nth-child(2),
            .hb-grid-4 > a:nth-child(3) {
              grid-column: 1 / -1 !important;
              display: grid !important;
              grid-template-columns: 1fr 150px !important;
              grid-template-rows: auto auto auto auto !important;
              gap: 2px 12px !important;
              padding-bottom: 16px !important; border-bottom: 1px solid #e5e5e5 !important;
              align-items: start !important;
            }
            .hb-grid-4 > a:nth-child(2) > div:first-child,
            .hb-grid-4 > a:nth-child(3) > div:first-child { grid-column: 2 / 3 !important; grid-row: 1 / 5 !important; aspect-ratio: 16/9 !important; align-self: start !important; }
            .hb-grid-4 > a:nth-child(2) > div:nth-child(2),
            .hb-grid-4 > a:nth-child(3) > div:nth-child(2) { grid-column: 1 / 2 !important; grid-row: 1 !important; font-size: 9px !important; letter-spacing: .2em !important; margin: 0 !important; }
            .hb-grid-4 > a:nth-child(2) > h3,
            .hb-grid-4 > a:nth-child(3) > h3 { grid-column: 1 / 2 !important; grid-row: 2 !important; font-size: 14px !important; line-height: 1.4 !important; margin: 0 !important; -webkit-line-clamp: unset !important; display: block !important; overflow: visible !important; }
            .hb-grid-4 > a:nth-child(2) > p,
            .hb-grid-4 > a:nth-child(3) > p { display: -webkit-box !important; grid-column: 1 / 2 !important; grid-row: 3 !important; -webkit-line-clamp: 2 !important; -webkit-box-orient: vertical !important; overflow: hidden; font-size: 11.5px !important; line-height: 1.55 !important; color: #555 !important; margin: 0 !important; }
            .hb-grid-4 > a:nth-child(2) > div[style*="fontMono"],
            .hb-grid-4 > a:nth-child(3) > div[style*="fontMono"],
            .hb-grid-4 > a:nth-child(2) > div[style*="font-family: ui-monospace"],
            .hb-grid-4 > a:nth-child(3) > div[style*="font-family: ui-monospace"] { grid-column: 1 / 2 !important; grid-row: 4 !important; font-size: 10px !important; padding-top: 4px !important; }

            /* #4 以降 — 2x2 paired (image-TOP + title only) */
            .hb-grid-4 > a:nth-child(n+4) {
              grid-column: span 1 !important;
              display: flex !important; flex-direction: column !important;
              gap: 6px !important;
            }
            .hb-grid-4 > a:nth-child(n+4) > div:first-child { aspect-ratio: 16/9 !important; }
            .hb-grid-4 > a:nth-child(n+4) > p { display: none !important; }
            .hb-grid-4 > a:nth-child(n+4) > div:nth-child(2) { font-size: 9px !important; letter-spacing: .2em !important; }
            .hb-grid-4 > a:nth-child(n+4) > h3 { font-size: 13px !important; line-height: 1.4 !important; margin: 3px 0 2px !important; -webkit-line-clamp: unset !important; display: block !important; overflow: visible !important; }
            .hb-grid-4 > a:nth-child(n+4) > div[style*="fontMono"], .hb-grid-4 > a:nth-child(n+4) > div[style*="font-family: ui-monospace"] { font-size: 10px !important; padding-top: 4px !important; }
            /* 「分野別 新着」セクション帯 — タイトに詰める (Cybozu / Economist の編集メディア基準) */
            .hb-sections-band-head { border-bottom: none !important; padding-bottom: 0 !important; margin-bottom: 14px !important; }
            .hb-sections-band { padding: 24px 10px 28px !important; }
            /* テーマグループ間スペース圧縮 (variant-d-loader の 24+24=48px → 14+12=26px) */
            /* インラインの padding:0 22px をモバイルで撲滅 (section の 10px と二重になり計 32px の左右余白を生む) */
            .hb-sections-grid > * { padding: 0 !important; padding-bottom: 14px !important; margin-bottom: 12px !important; }
            .hb-sections-grid > *:last-child { padding-bottom: 0 !important; margin-bottom: 0 !important; border-bottom: none !important; }
            /* lead 記事カード: 画像とタイトルの gap、padding-bottom 縮小 */
            .hb-sections-grid > * > a { gap: 6px !important; padding-bottom: 8px !important; }
            /* secondaries (h5 リスト): 縦 padding を半分以下に */
            .hb-sections-grid > * > ul > li { padding: 5px 0 !important; }
            /* セクションヘッダ (DX / AI 等 eyebrow + h3) の上余白を圧縮 */
            .hb-sections-grid > * > div:first-child { padding-top: 6px !important; margin-bottom: 2px !important; }
            /* マストヘッド (日付 + "全N記事" + ホーム/Blog + "The HatenaBase Review" タイトル) を非表示。
               スマホ画面では縦圧迫の元になるだけで情報価値が低いため。 */
            .hb-archive-masthead { display: none !important; }

            /* sticky filter — カテゴリースクロール bar を最上段に。
               左右ガターは 16px、検索ボックスを下段にラップさせ、
               カテゴリのみで第一視線が完結するように。 */
            .hb-archive-masthead + div { top: 56px !important; }
            .hb-archive-masthead + div > div {
              padding: 8px 0 0 !important;
              gap: 8px !important;
            }
            .hb-archive-masthead + div > div > div:first-child {
              padding: 0 16px !important;
              -webkit-overflow-scrolling: touch;
              scroll-snap-type: x proximity;
            }
            .hb-archive-masthead + div > div > div:first-child > a {
              scroll-snap-align: start;
              padding: 10px 14px !important;
              font-size: 13px !important;
            }
            /* 検索ボックス — モバイルではカテゴリ下に控えめに配置 */
            .hb-archive-masthead + div > div > div:last-child {
              margin: 0 16px 8px !important;
              min-width: 0 !important;
              width: calc(100% - 32px) !important;
            }
          }
        `}</style>
      </HBLayout>
    );
  }

  function CatTab({ active, href, children }) {
    return (
      <a href={href || '#'}
        style={{
          display:'inline-block', padding:'10px 18px',
          fontFamily:'"Zen Kaku Gothic New", sans-serif', fontSize:13, fontWeight: active ? 700 : 500,
          color: active ? '#1F61AB' : '#0A2846',
          borderBottom: active ? `2px solid #1F61AB` : `2px solid transparent`,
          whiteSpace:'nowrap', textDecoration:'none',
        }}>
        {children}
      </a>
    );
  }

  function NumericPager({ page, maxPage, basePath, prevUrl, nextUrl }) {
    const { hbcp, fontMono, fontEN } = window;
    // 表示するページ番号: 現在ページの前後 ±2 と 1, maxPage を含む
    const pages = [];
    const set = new Set([1, maxPage, page - 2, page - 1, page, page + 1, page + 2].filter(n => n >= 1 && n <= maxPage));
    const sorted = [...set].sort((a,b)=>a-b);
    let prev = 0;
    for (const n of sorted) {
      if (n - prev > 1) pages.push('…');
      pages.push(n);
      prev = n;
    }
    const linkOf = ( n ) => {
      if ( n === 1 ) return basePath;
      // WordPress の paged URL: {basePath}page/{n}/
      const bp = basePath.endsWith('/') ? basePath : basePath + '/';
      return `${bp}page/${n}/`;
    };
    return (
      <nav aria-label="Pagination" style={{display:'flex', justifyContent:'center', alignItems:'center', gap:6, marginTop:80, paddingTop:48, borderTop:`1px solid ${hbcp.line}`, fontFamily:fontMono, fontSize:13}}>
        <a href={prevUrl || '#'} aria-disabled={!prevUrl} style={{padding:'10px 14px', color: prevUrl ? hbcp.ink : hbcp.inkLight, textDecoration:'none', pointerEvents: prevUrl ? 'auto' : 'none', opacity: prevUrl ? 1 : .35}}>
          <span style={{fontFamily:fontEN}}>←</span> Newer
        </a>
        <ol style={{display:'flex', listStyle:'none', padding:0, margin:'0 8px', gap:2}}>
          {pages.map((n, i) => (
            <li key={i}>
              {n === '…'
                ? <span style={{padding:'10px 12px', color:hbcp.inkLight}}>…</span>
                : n === page
                  ? <span aria-current="page" style={{padding:'10px 14px', background:hbcp.ink, color:'#fff', fontWeight:700}}>{n}</span>
                  : <a href={linkOf(n)} style={{padding:'10px 14px', color:hbcp.ink, textDecoration:'none'}}>{n}</a>}
            </li>
          ))}
        </ol>
        <a href={nextUrl || '#'} aria-disabled={!nextUrl} style={{padding:'10px 14px', color: nextUrl ? hbcp.ink : hbcp.inkLight, textDecoration:'none', pointerEvents: nextUrl ? 'auto' : 'none', opacity: nextUrl ? 1 : .35}}>
          Older <span style={{fontFamily:fontEN}}>→</span>
        </a>
      </nav>
    );
  }

  Object.assign(window, { ArchiveListPage });
})();
